import apiPayment from "./pastChargesApi";
import {
  failed,
  morePastChargesLoading,
  pastChargesLoaded,
  pastChargesLoading,
  pastChargesMoreLoaded,
  pastStatementInformationLoaded,
  pastStatementInformationLoading,
} from "./pastChargesStateActions";
import { PageableBillingCycleSummary } from "../../../types/types";
import { PageableObjectOfBillingCycleSummaryModel } from "../../parentApi";

export function loadPastCharges(dispatch: any, customerAccountId: number, pageSize: number, pageIndex: number) {
  dispatch(pastChargesLoading());
  apiPayment.getBillingCycles(customerAccountId, pageIndex, pageSize, false).then(
    (response: PageableObjectOfBillingCycleSummaryModel | null) => {
      return dispatch(pastChargesLoaded(response ?? ({} as PageableBillingCycleSummary), pageIndex));
    },
    (error: any) => dispatch(failed())
  );
}

export function loadMore(dispatch: any, customerAccountId: number, pageSize: number, pageIndex: number) {
  dispatch(morePastChargesLoading());
  apiPayment.getBillingCycles(customerAccountId, pageIndex, pageSize, false).then(
    (response: PageableObjectOfBillingCycleSummaryModel | null) => {
      return dispatch(pastChargesMoreLoaded(response ?? ({} as PageableBillingCycleSummary), pageIndex));
    },
    (error: any) => dispatch(failed())
  );
}
function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export async function loadPastStatementInformation(
  dispatch: any,
  customerAccountId: number,
  pageSize: number,
  pageIndex: number
) {
  dispatch(pastStatementInformationLoading());
  await sleep(4000);
  apiPayment.getCurrentStatement(customerAccountId, pageIndex, pageSize).then(
    (charges: any) => dispatch(pastStatementInformationLoaded(charges, pageIndex)),
    function (error: any) {
      return dispatch(failed());
    }
  );
}
